import {
  COMMON_CAN_DELETE_BEGIN,
  COMMON_CAN_DELETE_SUCCESS,
  COMMON_CAN_DELETE_FAILURE,
  COMMON_RESET_CAN_DELETE,
} from '../constants'

export function reducer(state, action) {
  const defaultValue = { can: null, message: '' }
  switch (action.type) {
    case COMMON_CAN_DELETE_BEGIN:
    case COMMON_CAN_DELETE_FAILURE:
    case COMMON_RESET_CAN_DELETE:
      return {
        ...state,
        canDelete: defaultValue
      }
    case COMMON_CAN_DELETE_SUCCESS:
      return {
        ...state,
        canDelete: { ...action.data.data, type: action.data.type}
      }
    default:
      return state
  }
}
